import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { combineLatest, Observable, map } from 'rxjs';
import { AttributionDao } from '../attribution/attribution.dao';
import { Dao } from '../dao';
import { DataLoader } from '../data-loader';

@Injectable({
  providedIn: 'root',
})
export class ReferenceDao extends Dao {
  private availableOperations: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/pledge/available-operations`),
  );
  private assetTypes: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/assets/types`),
  );
  private childFiliations: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/childFilliation`).pipe(map(res => res['data'])),
  );
  private companyActivitySectors: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/companies/activity-sectors`),
  );
  private companyInvestorCategories: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/companies/investor-categories`),
  );
  private companyInvestorTypes: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/companies/investor-types`),
  );
  private companyLegalForms: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/companies/legal-forms`),
  );
  private companyTaxResidences: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/companies/tax-residences`),
  );
  private companyTaxSystems: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/companies/tax-systems`),
  );
  private countries: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/country`).pipe(map(res => res['data'])),
  );
  private cities: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/city`),
  );
  private swisslifeActivitySectors: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/swisslife-activity-sectors`),
  );
  private inseeActivitySectors: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/insee-activity-sectors`),
  );
  private department: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/department/fr`).pipe(map(res => res['data'])),
  );
  private estateType: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/immoExpenseType`).pipe(map(res => res['data'])),
  );
  private fiscalLaw: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/fiscallaw`).pipe(map(res => res['data'])),
  );
  private fiscalType: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/fiscalType`).pipe(map(res => res['data'])),
  );
  private immoExpenseType: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/immoExpenseType`).pipe(map(res => res['data'])),
  );
  private legalCapacity: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/legalCapacity`).pipe(map(res => res['data'])),
  );
  private loanProjetType: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/loanProjetType`).pipe(map(res => res['data'])),
  );
  private loanRateType: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/loanRateType`).pipe(map(res => res['data'])),
  );
  private maritalStatus: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/maritalStatus`),
  );
  private marriageRegime: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/marriageRegime`).pipe(map(res => res['data'])),
  );
  private ownershipTypes: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/product/realEstateOwnershipType`),
  );
  private scpiRepartitionGeoTypes: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/product/scpiSyntheseRepartitionGeo`),
  );
  private scpiRepartitionSectoTypes: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/product/scpiSyntheseRepartitionSecto`),
  );
  private periodicityType: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/periodicityType`).pipe(map(res => res['data'])),
  );
  private personalUseType: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/personalUseType`).pipe(map(res => res['data'])),
  );
  private productFiscalLaw: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/product/fiscalLaw`),
  );
  private realEstateOwnershipTypes: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/product/realEstateOwnershipType`),
  );
  private relationsType: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/relationType`).pipe(map(res => res['data'])),
  );
  private relationType: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/relationType`).pipe(map(res => res['data'])),
  );
  private scpi: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/products/scpi/history`),
  );
  private scpiSimulation: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/products/scpi/history?fromSimulation=true`),
  );
  private subscriptionSource: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/subscriptionSource`).pipe(map(res => res['data'])),
  );
  private supportTypes: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/support/type`),
  );
  private supports: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/supports`).pipe(map(res => res['content'])),
  );
  private tangibleCategory: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/tangibleCategory`).pipe(map(res => res['data'])),
  );
  private companyCristalisLegalForms: DataLoader<any> = new DataLoader<any>(
    () => this.httpApi.get(`/ref/comptability/company-cristalis-legal-form`),
  );

  constructor(
    httpApi: HttpApiService,
    authentificationService: AuthentificationService,
    private attributionDao: AttributionDao,
  ) {
    super(httpApi, authentificationService);
  }

  getAvailableOperations() {
    return this.availableOperations.get();
  }
  getAssetTypes() {
    return this.assetTypes.get();
  }
  getChildFiliations() {
    return this.childFiliations.get();
  }
  getCompanyActivitySectors() {
    return this.companyActivitySectors.get();
  }
  getCompanyInvestorCategories() {
    return this.companyInvestorCategories.get();
  }
  getCompanyInvestorTypes() {
    return this.companyInvestorTypes.get();
  }
  getCompanyLegalForms() {
    return this.companyLegalForms.get();
  }
  getCompanyTaxResidences() {
    return this.companyTaxResidences.get();
  }
  getCompanyTaxSystems() {
    return this.companyTaxSystems.get();
  }
  getCountries() {
    return this.countries.get();
  }
  getCities() {
    return this.cities.get();
  }
  getSwisslifeActivitySectors() {
    return this.swisslifeActivitySectors.get();
  }
  getInseeActivitySectors() {
    return this.inseeActivitySectors.get();
  }
  getDepartment() {
    return this.department.get();
  }
  getEstateType() {
    return this.estateType.get();
  }
  getFiscalLaw() {
    return this.fiscalLaw.get();
  }
  getFiscalType() {
    return this.fiscalType.get();
  }
  getImmoExpenseType() {
    return this.immoExpenseType.get();
  }
  getLegalCapacity() {
    return this.legalCapacity.get();
  }
  getLoanProjetType() {
    return this.loanProjetType.get();
  }
  getLoanRateType() {
    return this.loanRateType.get();
  }
  getMaritalStatus() {
    return this.maritalStatus.get();
  }
  getMarriageRegime() {
    return this.marriageRegime.get();
  }
  getOwnershipTypes() {
    return this.ownershipTypes.get();
  }
  getScpiRepartitionGeoTypes() {
    return this.scpiRepartitionGeoTypes.get();
  }
  getScpiRepartitionSectoTypes() {
    return this.scpiRepartitionSectoTypes.get();
  }
  getPeriodicityType() {
    return this.periodicityType.get();
  }
  getPersonalUseType() {
    return this.personalUseType.get();
  }
  getProductFiscalLaw() {
    return this.productFiscalLaw.get();
  }
  getRealEstateOwnershipTypes() {
    return this.realEstateOwnershipTypes.get();
  }
  getRelationsTypes() {
    return this.relationsType.get();
  }
  getRelationType() {
    return this.relationType.get();
  }
  getScpi() {
    return this.scpi.get();
  }
  getScpiSimulation() {
    return this.scpiSimulation.get();
  }
  getSubscriptionSource() {
    return combineLatest([
      this.subscriptionSource.get(),
      this.attributionDao.getOrganization(),
    ]).pipe(
      map(([sources, organization]) => {
        return sources.map((s: any) => {
          if (String(s.id).toUpperCase() === 'INTERNAL') {
            return {
              ...s,
              value: organization.name,
            };
          }
          return s;
        });
      }),
    );
  }
  getSupportTypes() {
    return this.supportTypes.get();
  }
  getSupports() {
    return this.supports.get();
  }
  getTangibleCategory() {
    return this.tangibleCategory.get();
  }
  getCompanyCristalisLegalForms() {
    return this.companyCristalisLegalForms.get();
  }
  reset() {
    this.availableOperations?.reset();
    this.assetTypes?.reset();
    this.childFiliations?.reset();
    this.companyActivitySectors?.reset();
    this.companyInvestorCategories?.reset();
    this.companyInvestorTypes?.reset();
    this.companyLegalForms?.reset();
    this.companyTaxResidences?.reset();
    this.companyTaxSystems?.reset();
    this.countries?.reset();
    this.cities?.reset();
    this.swisslifeActivitySectors?.reset();
    this.inseeActivitySectors?.reset();
    this.department?.reset();
    this.estateType?.reset();
    this.fiscalLaw?.reset();
    this.fiscalType?.reset();
    this.immoExpenseType?.reset();
    this.legalCapacity?.reset();
    this.loanProjetType?.reset();
    this.loanRateType?.reset();
    this.maritalStatus?.reset();
    this.marriageRegime?.reset();
    this.ownershipTypes?.reset();
    this.scpiRepartitionGeoTypes?.reset();
    this.scpiRepartitionSectoTypes?.reset();
    this.periodicityType?.reset();
    this.personalUseType?.reset();
    this.productFiscalLaw?.reset();
    this.realEstateOwnershipTypes?.reset();
    this.relationsType?.reset();
    this.relationType?.reset();
    this.scpi?.reset();
    this.scpiSimulation?.reset();
    this.subscriptionSource?.reset();
    this.supportTypes?.reset();
    this.supports?.reset();
    this.tangibleCategory?.reset();
  }

  /* state */
  onUserChange(event: any) {
    this?.reset();
  }

  findScpiBasedOnId(id): Observable<any> {
    return this.getScpiSimulation().pipe(
      map(scpis => scpis.find(scpi => id == scpi.id)),
    );
  }
}
